import { isBuild, typeViteEnv } from '@/utils/env'
import { trim, getRandomNumber, checkFileType } from '@/utils/util'

export function handleArticleStr(str, nextCallback, type: 'mobile' | 'pc') {
  if (!str) return ''
  const isMobile =
    /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile|iPhone|Mobile/.test(
      navigator.userAgent
    )

  const centerDom = document.querySelectorAll('#newContent center')

  for (let i = 0; i < centerDom.length; i++) {
    const html = centerDom[i].innerHTML
    const el = document.createElement('p')
    el.innerHTML = html
    centerDom[i].before(el)
    centerDom[i].remove()
  }

  const imageDom = document.querySelectorAll('#newContent img')
  const videoDom = document.querySelectorAll('#newContent video')
  const audioDom = document.querySelectorAll('#newContent [class^="audio-block"]')
  const linkCardDom = document.querySelectorAll('#newContent .linkcard')
  const swiperDom = document.querySelectorAll('#newContent ._editor16')
  const swiper2Dom = document.querySelectorAll('#newContent ._editor27')
  const leftOrRight = document.querySelectorAll(`#newContent section[data-title='左文右图']`)
  const leftOrRight2 = document.querySelectorAll(`#newContent section[data-title='左图右文']`)
  const imgPut = document.querySelectorAll('#newContent .edit_img_input')
  const imgPut2 = document.querySelectorAll('#newContent .imageCaption')

  const swiperText = document.querySelectorAll(`#newContent section[data-title='文字滚动']`)
  const tableDom = document.querySelectorAll('#newContent ._editor24')

  const text1Dom = document.querySelectorAll(`#newContent section[data-title='文本框1']`)
  const text2Dom = document.querySelectorAll(`#newContent section[data-title='文本框2']`)
  const text3Dom = document.querySelectorAll(`#newContent section[data-title='文本框3']`)
  const text4Dom = document.querySelectorAll(`#newContent section[data-title='文本框4']`)
  const text5Dom = document.querySelectorAll(`#newContent section[data-title='文本框5']`)

  const authorDom = document.querySelectorAll(`#newContent section[data-title='作者头像框']`)

  const textChangeDom = document.querySelectorAll(`#newContent section[data-title='文字切换']>div`)
  const textSplit5Dom = document.querySelectorAll(`#newContent section[data-title='分割线-5']>div`)

  const brDom = document.querySelectorAll(`#newContent p > br`)

  // 处理作者头像
  for (let i = 0; i < authorDom.length; i++) {
    if (!isMobile) {
      let name = ''
      let from = ''
      let career = ''
      let imageSrc = ''
      const el = document.createElement('div')
      el.classList.add('en-author')

      const imageEl = authorDom[i].querySelector('img')
      const nameEl = authorDom[i].querySelector('div#name')
      const fromEl = authorDom[i].querySelector('div#from')
      const careerEl = authorDom[i].querySelector('div#career')

      if (imageEl) {
        imageSrc = imageEl.getAttribute('src')
      }

      if (nameEl) {
        name = nameEl.textContent
      }

      if (fromEl) {
        from = fromEl.textContent
      }

      if (careerEl) {
        career = careerEl.textContent
      }
      el.innerHTML = `<div class="author-left"><img class="not-preview-image" src="${imageSrc}" alt="People's Daily English language App "></div><div class="author-right"><div class="author-name droidSerif-bold">${name}</div><div class="author-from">${from}</div><div class="author-career">${career}</div></div>`
      authorDom[i].before(el)
      authorDom[i].remove()
    }
  }

  // 处理分割线5
  for (let i = 0; i < textSplit5Dom.length; i++) {
    if (textSplit5Dom[i].querySelector('div#sign')) {
      // @ts-ignore
      textSplit5Dom[i].querySelector('div#sign').style.background = '#fff'
    }
  }

  // 处理换行的间距
  for (let i = 0; i < brDom.length; i++) {
    // @ts-ignore
    if (brDom[i].parentNode) {
      // @ts-ignore
      if (brDom[i].parentNode?.childNodes?.length === 1) {
        // @ts-ignore
        if (brDom[i].parentNode?.childNodes?.[0]?.tagName === 'BR') {
          // @ts-ignore
          brDom[i].parentNode?.setAttribute(
            'style',
            'margin-bottom: 0 !important;height: 0 !important;'
          )
        }
      }
    }
  }

  // 处理文字切换
  for (let i = 0; i < textChangeDom.length; i++) {
    // @ts-ignore
    textChangeDom[i].style.width = '100%'
  }

  // 处理文本1
  for (let i = 0; i < text1Dom.length; i++) {
    const publicImageUrl = isBuild()
      ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image'
      : '/src/assets/image'

    let title = ''
    let bgHex = ''
    let borderColor = ''
    let styleString = ''
    const contentStyle = {} as any
    const el = document.createElement('div')
    el.classList.add('en-text-1')
    const borderEl = text1Dom[i].querySelector('div#border') as HTMLElement
    const titleEl = text1Dom[i].querySelector('p#content') as HTMLElement
    if (titleEl) {
      title = titleEl.textContent || ''
      const inlineStyles = titleEl.style
      for (let i = 0; i < inlineStyles.length; i++) {
        const property = inlineStyles[i]

        // 你可以选择性地过滤或直接复制所有内联样式
        if (
          !property.startsWith('padding') &&
          !property.includes('margin') &&
          !property.includes('width') &&
          !property.includes('height') &&
          property !== 'line-height' &&
          property !== 'font-size' &&
          property !== 'font-family'
        ) {
          contentStyle[property] = inlineStyles.getPropertyValue(property)
        }
      }
      for (const property in contentStyle) {
        if (contentStyle.hasOwnProperty(property)) {
          styleString += `${property}: ${contentStyle[property]}; `
        }
      }
    }

    if (borderEl) {
      bgHex = borderEl.style.backgroundColor
      borderColor = borderEl.style.borderInlineStartColor
    }
    el.style.borderLeftColor = borderColor
    el.style.backgroundColor = bgHex
    el.innerHTML = `<img data-src="${publicImageUrl}/textDesIcon.svg" class="not-preview-image local-image" src="${publicImageUrl}/textDesIcon.svg" alt="People's Daily English language App "><div class="en-text-1-title" style="${styleString}">${title}</div>`
    text1Dom[i].before(el)
    text1Dom[i].remove()
  }

  // 处理文本2
  for (let i = 0; i < text2Dom.length; i++) {
    let title = ''
    let borderColor = ''
    let styleString = ''
    const contentStyle = {} as any
    const el = document.createElement('div')
    el.classList.add('en-text-2')
    const borderEl = text2Dom[i].querySelector('div#border') as HTMLElement
    const titleEl = text2Dom[i].querySelector('div#content') as HTMLElement
    if (titleEl) {
      title = titleEl.textContent || ''
      const inlineStyles = titleEl.style
      for (let i = 0; i < inlineStyles.length; i++) {
        const property = inlineStyles[i]

        // 你可以选择性地过滤或直接复制所有内联样式
        if (
          !property.startsWith('padding') &&
          !property.includes('margin') &&
          !property.includes('width') &&
          !property.includes('height') &&
          property !== 'line-height' &&
          property !== 'font-size' &&
          property !== 'font-family'
        ) {
          contentStyle[property] = inlineStyles.getPropertyValue(property)
        }
      }
      for (const property in contentStyle) {
        if (contentStyle.hasOwnProperty(property)) {
          styleString += `${property}: ${contentStyle[property]}; `
        }
      }
    }

    if (borderEl) {
      borderColor = borderEl.style.borderColor
    }
    el.style.borderColor = borderColor
    el.innerHTML = `<div class="en-text-2-title" style="${styleString}">${title}</div>`
    text2Dom[i].before(el)
    text2Dom[i].remove()
  }

  // 处理文本3
  for (let i = 0; i < text3Dom.length; i++) {
    let title = ''
    let content = ''
    let borderColor = ''
    let styleString = ''
    let titleStyleStr = ''
    const titleStyle = {} as any
    const contentStyle = {} as any
    const el = document.createElement('div')
    el.classList.add('en-text-3')
    const borderEl = text3Dom[i].querySelector('div#border') as HTMLElement
    const titleEl = text3Dom[i].querySelector('span#title') as HTMLElement
    const contentEl = text3Dom[i].querySelector('p#content') as HTMLElement
    if (titleEl) {
      title = titleEl.textContent || ''
      const inlineStyles = titleEl.style
      for (let i = 0; i < inlineStyles.length; i++) {
        const property = inlineStyles[i]

        // 你可以选择性地过滤或直接复制所有内联样式
        if (
          !property.startsWith('padding') &&
          !property.includes('margin') &&
          !property.includes('width') &&
          !property.includes('height') &&
          property !== 'line-height' &&
          property !== 'font-size' &&
          property !== 'font-family'
        ) {
          titleStyle[property] = inlineStyles.getPropertyValue(property)
        }
      }
      for (const property in titleStyle) {
        if (titleStyle.hasOwnProperty(property)) {
          titleStyleStr += `${property}: ${titleStyle[property]}; `
        }
      }
    }

    if (borderEl) {
      borderColor = borderEl.style.borderColor
    }

    if (contentEl) {
      content = contentEl.textContent || ''
      const inlineStyles = contentEl.style
      for (let i = 0; i < inlineStyles.length; i++) {
        const property = inlineStyles[i]

        // 你可以选择性地过滤或直接复制所有内联样式
        if (
          !property.startsWith('padding') &&
          !property.includes('margin') &&
          !property.includes('width') &&
          !property.includes('height') &&
          property !== 'line-height' &&
          property !== 'font-size' &&
          property !== 'font-family'
        ) {
          contentStyle[property] = inlineStyles.getPropertyValue(property)
        }
      }
      for (const property in contentStyle) {
        if (contentStyle.hasOwnProperty(property)) {
          styleString += `${property}: ${contentStyle[property]}; `
        }
      }
    }

    el.style.borderColor = borderColor
    el.innerHTML = `<div class="en-text-3-title droidSerif-bold" style="${titleStyleStr}"><i class="en-text-3-point" style="background: ${borderColor}"></i>${title}</div><div class="en-text-3-content" style="${styleString}">${content}</div>`
    text3Dom[i].before(el)
    text3Dom[i].remove()
  }

  // 处理文本4
  for (let i = 0; i < text4Dom.length; i++) {
    let title = ''
    let bgHex = ''
    let styleString = ''
    const contentStyle = {} as any
    const el = document.createElement('div')
    el.classList.add('en-text-4')
    const borderEl = text4Dom[i].querySelector('div#border') as HTMLElement
    const titleEl = text4Dom[i].querySelector('h4#title') as HTMLElement
    if (titleEl) {
      title = titleEl.textContent || ''
      const inlineStyles = titleEl.style
      for (let i = 0; i < inlineStyles.length; i++) {
        const property = inlineStyles[i]

        // 你可以选择性地过滤或直接复制所有内联样式
        if (
          !property.startsWith('padding') &&
          !property.includes('margin') &&
          !property.includes('width') &&
          !property.includes('height') &&
          property !== 'line-height' &&
          property !== 'font-size' &&
          property !== 'font-family'
        ) {
          contentStyle[property] = inlineStyles.getPropertyValue(property)
        }
      }
      for (const property in contentStyle) {
        if (contentStyle.hasOwnProperty(property)) {
          styleString += `${property}: ${contentStyle[property]}; `
        }
      }
    }

    if (borderEl) {
      bgHex = borderEl.style.backgroundColor
    }
    el.innerHTML = `<div class="en-text-4-block" style="background-color: ${bgHex}"><div class="en-text-4-title droidSerif-bold" style="${styleString}">${title}</div><div class="en-text-4-end" style="background: ${bgHex}"></div></div>`
    text4Dom[i].before(el)
    text4Dom[i].remove()
  }

  // 处理文本5
  for (let i = 0; i < text5Dom.length; i++) {
    let title = ''
    let num = ''
    let numBg = ''
    let numColor = ''
    let styleString = ''
    const contentStyle = {} as any
    const el = document.createElement('div')
    el.classList.add('en-text-5')
    const numEl = text5Dom[i].querySelector('div#sign') as HTMLElement
    if (numEl) {
      num = numEl.textContent || ''
      numBg = numEl.style.backgroundColor
      numColor = numEl.style.color
    }
    const titleEl = text5Dom[i].querySelector('h4#title') as HTMLElement
    if (titleEl) {
      title = titleEl.textContent || ''
      const inlineStyles = titleEl.style
      for (let i = 0; i < inlineStyles.length; i++) {
        const property = inlineStyles[i]

        // 你可以选择性地过滤或直接复制所有内联样式
        if (
          !property.startsWith('padding') &&
          !property.includes('margin') &&
          !property.includes('width') &&
          !property.includes('height') &&
          property !== 'line-height' &&
          property !== 'font-size' &&
          property !== 'font-family'
        ) {
          contentStyle[property] = inlineStyles.getPropertyValue(property)
        }
      }
      for (const property in contentStyle) {
        if (contentStyle.hasOwnProperty(property)) {
          styleString += `${property}: ${contentStyle[property]}; `
        }
      }
    }

    el.innerHTML = `<div class="en-text-5-block"><div class="en-text-5-num droidSerif-bold" style="color: ${numColor}; background: ${numBg}">${num}</div><div class="en-text-5-title droidSerif-bold" style="${styleString}">${title}</div></div>`
    text5Dom[i].before(el)
    text5Dom[i].remove()
  }

  // 处理表格
  for (let i = 0; i < tableDom.length; i++) {
    let title = ''
    const el = document.createElement('div')
    el.classList.add('en-table')
    const titleEl = tableDom[i].querySelector('span:first-child')
    if (titleEl) {
      title = titleEl.textContent
    }
    const tableHtml = tableDom[i].querySelector('table').innerHTML
    const tableStyle = tableDom[i].querySelector('table').getAttribute('style')
    el.innerHTML = `<div class="en-table-title droidSerif-bold">${title}</div><table style="${tableStyle}">${tableHtml}</table>`
    tableDom[i].before(el)
    tableDom[i].remove()
  }

  // 处理轮播字幕
  for (let i = 0; i < swiperText.length; i++) {
    const publicImageUrl = isBuild()
      ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image'
      : '/src/assets/image'
    const el = document.createElement('div')
    el.classList.add('en-scroll-text')
    let text = ''
    let imgSrc = ''
    const textEl = swiperText[i].querySelector('tspan')
    const imgEl = swiperText[i].querySelector('img')
    if (textEl) {
      text = textEl.textContent
    }

    if (imgEl) {
      imgSrc = imgEl.getAttribute('src')
    }
    el.innerHTML = `<div class="scroll-text-left"><img class="not-preview-image" src="${
      imgSrc || `${publicImageUrl}/scrollText.svg`
    }" alt="People's Daily English language App "></div><div class="swiper-txet">${text}</div>`
    swiperText[i].before(el)
    swiperText[i].remove()
  }

  // 处理图注
  for (let i = 0; i < imgPut.length; i++) {
    const el = document.createElement('div')
    el.innerText = imgPut[i]?.textContent || ''
    el.classList.add('rmrb-caption-img')
    imgPut[i].before(el)
    imgPut[i].remove()
  }

  // 处理图注2
  for (let i = 0; i < imgPut2.length; i++) {
    const text = imgPut2[i]
      ? imgPut2[i].querySelector('.title')
        ? imgPut2[i].querySelector('.title').textContent || ''
        : ''
      : ''
    if (text) {
      const el = document.createElement('div')
      el.innerText = text
      el.classList.add('rmrb-caption-img2')
      imgPut2[i].before(el)
      imgPut2[i].remove()
    }
  }

  // 处理左图右文
  for (let i = 0; i < leftOrRight2.length; i++) {
    const publicImageUrl = isBuild()
      ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image'
      : '/src/assets/image'

    if (isMobile) {
      const imageElList = leftOrRight2[i].querySelectorAll('img')

      for (let j = 0; j < imageElList.length; j++) {
        imageElList[j].style.objectFit = 'cover'
        imageElList[j].classList.add('not-preview-image')
      }
    } else {
      let title = ''
      let des = ''
      let imageSrc = ''
      const el = document.createElement('div')
      el.classList.add('en-right-text')

      const titleEl = leftOrRight2[i].querySelector('h3')
      const desEl = leftOrRight2[i].querySelector('p')
      const imageEl = leftOrRight2[i].querySelector('img')

      if (titleEl) {
        title = titleEl.textContent
      }

      if (desEl) {
        des = desEl.textContent
      }

      if (imageEl) {
        imageSrc = imageEl.getAttribute('src')
      }

      el.innerHTML = `<div class="en-left-text_left"><img src="${imageSrc}" alt="People's Daily English language App "></div><div class="en-left-text_right"><div class="en-left-text_tilte droidSerif-bold">${title}</div><div class="en-left-text_des">${des}<img class="not-preview-image" src="${publicImageUrl}/textDesIcon.svg" alt="People's Daily English language App "></div></div>`
      leftOrRight2[i].before(el)
      leftOrRight2[i].remove()
    }
  }

  // 处理左文右图
  for (let i = 0; i < leftOrRight.length; i++) {
    const publicImageUrl = isBuild()
      ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image'
      : '/src/assets/image'

    if (isMobile) {
      const imageElList = leftOrRight[i].querySelectorAll('img')

      for (let j = 0; j < imageElList.length; j++) {
        imageElList[j].style.objectFit = 'cover'
        imageElList[j].classList.add('not-preview-image')
      }
    } else {
      let title = ''
      let des = ''
      let imageSrc = ''
      const el = document.createElement('div')
      el.classList.add('en-left-text')

      const titleEl = leftOrRight[i].querySelector('h3')
      const desEl = leftOrRight[i].querySelector('p')
      const imageEl = leftOrRight[i].querySelector('img')

      if (titleEl) {
        title = titleEl.textContent
      }

      if (desEl) {
        des = desEl.textContent
      }

      if (imageEl) {
        imageSrc = imageEl.getAttribute('src')
      }

      el.innerHTML = `<div class="en-left-text_left"><div class="en-left-text_tilte droidSerif-bold">${title}</div><div class="en-left-text_des">${des}<img class="not-preview-image" src="${publicImageUrl}/textDesIcon.svg" alt="People's Daily English language App "></div></div><div class="en-left-text_right"><img src="${imageSrc}" alt="People's Daily English language App "></div>`
      leftOrRight[i].before(el)
      leftOrRight[i].remove()
    }
  }

  // 处理轮播图
  for (let i = 0; i < swiperDom.length; i++) {
    const publicImageUrl = isBuild()
      ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image'
      : '/src/assets/extraIcon'
    const id = `rmrb-en-swiper_${i + 1}`
    const el = document.createElement('div')
    el.setAttribute('id', `${id}`)
    el.setAttribute('class', `${isMobile ? 'mobile swiper-block' : 'swiper-block'}`)
    const srcElList: any = swiperDom[i].querySelectorAll('g foreignObject svg')
    const alEl: any = swiperDom[i].querySelector('g animateTransform')

    const isLoop = alEl?.getAttribute('repeatCount') === 'indefinite'
    const time = alEl?.getAttribute('dur')

    const urlList = []

    if (srcElList) {
      for (let j = 0; j < srcElList.length; j++) {
        const backgroundImage = srcElList[j].style.backgroundImage
        const url = backgroundImage.match(/url\("(.+)"\)/)[1]

        if (j !== 0) {
          urlList.push(url)
        }
      }
    }

    let html = '<div class="swiper-wrapper">'

    urlList.forEach((el) => {
      if (isMobile) {
        html += `<div class="swiper-slide"><img src="${el}" alt="People's Daily English language App "></div>`
      } else {
        html += `<div class="swiper-slide"><img src="${el}" alt="People's Daily English language App "></div>`
      }
    })

    el.innerHTML =
      html +
      `</div>${
        isMobile
          ? `<div class="swiper-pagination"></div>`
          : `<div class="swiper-nav swiper-prev"><img class="not-preview-image" src="${publicImageUrl}/icon_right.svg" alt="People's Daily English language App "></div><div class="swiper-nav swiper-next"><img class="not-preview-image" src="${publicImageUrl}/icon_left.svg" alt="People's Daily English language App "></div><div class="swiper-pagination"></div>`
      }`

    swiperDom[i].before(el)
    swiperDom[i].remove()

    nextCallback(3, {
      id: `#${id}`,
      isLoop,
      length: urlList.length,
      time: parseInt(time)
    })
  }

  // 处理海报轮播图
  for (let i = 0; i < swiper2Dom.length; i++) {
    const publicImageUrl = isBuild()
      ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image'
      : '/src/assets/extraIcon'
    const id = `rmrb-en-poster-swiper_${i + 1}`
    const el = document.createElement('div')
    el.setAttribute('id', `${id}`)
    el.setAttribute('class', `${isMobile ? 'mobile swiper-block' : 'swiper-block'}`)
    const srcElList: any = swiper2Dom[i].querySelectorAll('g foreignObject svg')
    const alEl: any = swiper2Dom[i].querySelector('g animateTransform')

    const isLoop = alEl?.getAttribute('repeatCount') === 'indefinite'
    const time = alEl?.getAttribute('dur')

    const urlList = []

    if (srcElList) {
      for (let j = 0; j < srcElList.length; j++) {
        const backgroundImage = srcElList[j].style.backgroundImage
        const url = backgroundImage.match(/url\("(.+)"\)/)[1]

        if (j !== 0) {
          urlList.push(url)
        }
      }
    }

    let html = '<div class="swiper-wrapper">'

    urlList.forEach((el) => {
      if (isMobile) {
        html += `<div class="swiper-slide"><img src="${el}" alt="People's Daily English language App "></div>`
      } else {
        html += `<div class="swiper-slide"><img src="${el}" alt="People's Daily English language App "></div>`
      }
    })

    el.innerHTML =
      html +
      `</div>${
        isMobile
          ? `<div class="swiper-pagination"></div>`
          : `<div class="swiper-nav swiper-prev"><img class="not-preview-image" src="${publicImageUrl}/icon_right.svg" alt="People's Daily English language App "></div><div class="swiper-nav swiper-next"><img class="not-preview-image" src="${publicImageUrl}/icon_left.svg" alt="People's Daily English language App "></div><div class="swiper-pagination"></div>`
      }`

    swiper2Dom[i].before(el)
    swiper2Dom[i].remove()

    nextCallback(4, {
      id: `#${id}`,
      isLoop,
      length: urlList.length,
      time: parseInt(time)
    })
  }

  for (let i = 0; i < linkCardDom.length; i++) {
    const publicImageUrl = isBuild()
      ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image'
      : '/src/assets/article'

    const titleEl =
      linkCardDom[i].querySelector('span.title') || linkCardDom[i].querySelector('span')

    const title = titleEl ? titleEl.textContent : trim(linkCardDom[i].textContent || '')
    const image = linkCardDom[i].querySelector('img')
    const a = linkCardDom[i].querySelector('a') || linkCardDom[i].querySelector('p:last-child')

    let imageUrl = image ? image.getAttribute('src') || image.getAttribute('data-src') : ''

    imageUrl = checkFileType(imageUrl) === '1' ? imageUrl : ''

    const hrefUrl = a
      ? a.getAttribute('href') ||
        a.getAttribute('_href') ||
        a.getAttribute('data-href') ||
        a.textContent
      : ''
    const dataRmrbnativeEl = linkCardDom[i].querySelector('p.link')

    const el = document.createElement('a')
    let classNames = imageUrl ? 'card-image' : ''
    classNames += ` ${isMobile ? 'preview-link-card-mobile' : 'preview-link-card'}`
    el.setAttribute('class', classNames)
    el.setAttribute(
      'data-rmrbnative',
      dataRmrbnativeEl ? dataRmrbnativeEl.getAttribute('data-rmrbnative') || '' : ''
    )
    el.setAttribute('href', hrefUrl || '')
    el.setAttribute('target', '_blank')

    const linkIcon = `icon_Y_lianjie`

    if (isMobile) {
      if (imageUrl) {
        el.innerHTML = `<div class="left"><img data-src="${imageUrl}" class="not-preview-image local-image" src="${imageUrl}" alt="People's Daily English language App "></div><div class="right"><div class="preview-link-title droidSerif-bold"><img class="not-preview-image local-image" data-src="${publicImageUrl}/${linkIcon}.svg" src="${publicImageUrl}/${linkIcon}.svg" alt="People's Daily English language App ">${title}</div><div class="preview-link"><span>${
          hrefUrl || ''
        }</span></div></div>`
      } else {
        el.innerHTML = `<div class="preview-link-title droidSerif-bold"><img class="not-preview-image local-image" src="${publicImageUrl}/${linkIcon}.svg" data-src="${publicImageUrl}/${linkIcon}.svg" alt="People's Daily English language App ">${title}</div><div class="preview-link"><span>${
          hrefUrl || ''
        }</span></div>`
      }
    } else {
      if (imageUrl) {
        el.innerHTML = `<div class="left"><img data-src="${imageUrl}" class="not-preview-image local-image" src="${imageUrl}" alt="People's Daily English language App "></div><div class="right"><div class="preview-link-title droidSerif-bold"><img class="not-preview-image local-image" data-src="${publicImageUrl}/${linkIcon}.svg" src="${publicImageUrl}/${linkIcon}.svg" alt="People's Daily English language App "><span>${title}</div><div class="preview-link">${
          hrefUrl || ''
        }</span></div></div>`
      } else {
        el.innerHTML = `<div class="preview-link-title droidSerif-bold"><img class="not-preview-image local-image" src="${publicImageUrl}/${linkIcon}.svg" data-src="${publicImageUrl}/${linkIcon}.svg" alt="People's Daily English language App ">${title}</div><div class="preview-link">${
          hrefUrl || ''
        }</span></div>`
      }
    }

    linkCardDom[i].before(el)
    linkCardDom[i].remove()
  }

  for (let i = 0; i < audioDom.length; i++) {
    const id = audioDom[i].getAttribute('id') || ''
    const dataId = `en_audio_${i}`
    let audioEl
    let coverEl
    let titleEl
    let title = ''
    let cover = ''
    let audioSrc = ''

    if (id === '_editor36') {
      audioEl = audioDom[i].querySelector('.ueditor_style_audio source')
      coverEl = audioDom[i].querySelector('.audioStyleLeftImg')
      if (!coverEl) {
        coverEl = audioDom[i].querySelector('img.audioStyleLeftImg')
      }
      titleEl = audioDom[i].querySelector('.audioStyleTitle')
      if (titleEl) {
        title = titleEl.innerHTML
      }
      if (audioEl) {
        audioSrc = audioEl.getAttribute('src')
      }
      cover = coverEl?.getAttribute('src')
    } else {
      audioEl = audioDom[i].querySelector('.ueditor_style_audio source')
      titleEl = audioDom[i].querySelector('.audioStyleTitle')
      if (titleEl) {
        title = titleEl.innerHTML
      }
      if (audioEl) {
        audioSrc = audioEl.getAttribute('src') || ''
      }
    }

    const el = document.createElement('div')
    el.setAttribute('data-id', dataId)
    el.setAttribute('class', cover ? 'preview-audio-player-cover' : 'preview-audio-player')
    const publicImageUrl = isBuild()
      ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image'
      : '/resource/image'
    const pauseIcon = `audioPause`
    const playIcon = `audioPlay`

    const noCoverTitle = `<div class="audio-title ellipsis1 droidSerif-bold">${title}</div>`
    if (cover) {
      if (isMobile) {
        el.innerHTML = `<audio src="${audioSrc}" class="audio-block hidden"></audio><div class="audio-cover" style="background-image: url('${cover}')"></div><div class="audio-details" style="width: 100%"><div class="audio-title ellipsis1 droidSerif-bold">${title}</div><div class="audio-extral"><div class="audio-time"><span class="audio-current droidSerif">00:00</span><span class="droidSerif audio-current">/</span><span class="audio-durtion droidSerif">00:00</span></div><div class="audio-extral-iocn"><div class="audio-bg"><img src="${publicImageUrl}/audioBg.png" alt="People's Daily English language App "><img class="audio-play-icon active mobileIcon" src="${publicImageUrl}/${pauseIcon}.svg" alt="People's Daily English language App "><img class="audio-pause-icon mobileIcon" src="${publicImageUrl}/${playIcon}.svg" alt="People's Daily English language App "></div></div></div></div>`
      } else {
        el.innerHTML = `<audio src="${audioSrc}" class="audio-block hidden"></audio><div class="audio-cover" style="background-image: url('${cover}')"></div><div class="audio-details" style="width: 100%"><div class="audio-title ellipsis1 droidSerif-bold">${title}</div><div class="audio-extral"><img class="audio-play-icon active mobileIcon" src="${publicImageUrl}/${pauseIcon}.svg" alt="People's Daily English language App "><img class="audio-pause-icon mobileIcon" src="${publicImageUrl}/${playIcon}.svg" alt="People's Daily English language App "><div class="audio-time"><span class="audio-current droidSerif">00:00</span><span class="droidSerif audio-current">/</span><span class="audio-durtion droidSerif">00:00</span></div><div class="audio-extral-iocn"><div class="audio-bg"><img src="${publicImageUrl}/audioBg.png" alt="People's Daily English language App "></div></div></div></div>`
      }
    } else {
      el.innerHTML = `<audio src="${audioSrc}" class="audio-block hidden"></audio>
            <div class="audio-details"><div class="audio-extral"><div class="left">${
              title ? noCoverTitle : ''
            }<div style="font-size: ${
        title ? undefined : '0.35rem'
      }" class="audio-time"><span class="audio-current droidSerif">00:00</span><span class="droidSerif audio-current">/</span><span class="audio-durtion droidSerif">00:00</span></div></div><div class="right"><img class="audio-play-icon active" src="${publicImageUrl}/${pauseIcon}.svg" alt="People's Daily English language App "><img class="audio-pause-icon" src="${publicImageUrl}/${playIcon}.svg" alt="People's Daily English language App "></div></div></div>`
    }

    if (audioSrc) {
      audioDom[i].before(el)
    }

    audioDom[i].remove()
  }

  const effectImage: HTMLElement[] = []
  for (let i = 0; i < imageDom.length; i++) {
    const name = imageDom[i].getAttribute('data-name')
    const classList = imageDom[i].getAttribute('class') || ''
    const src = imageDom[i].getAttribute('src')
    if (
      src &&
      src !== 'undefined' &&
      !classList.includes('not-preview-image') &&
      name !== 'people'
    ) {
      effectImage.push(imageDom[i] as HTMLElement)
    }
  }

  for (let i = 0; i < effectImage.length; i++) {
    const publicImageUrl = isBuild()
      ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image'
      : '/resource/image'

    const src = effectImage[i].getAttribute('src')

    if (src) {
      const includesTag = ['A']
      // @ts-ignore
      if (!includesTag.includes(effectImage[i].parentNode?.tagName)) {
        const el = document.createElement('div')
        el.setAttribute('class', 'preview-image-block')
        el.innerHTML = `<img class="image-player none image-player-${i}" src="${src}" alt="People's Daily English language App " data-src="${src}"><img class="preview-image-placehold none" src="" alt="People's Daily English language App "><img class="preview-image-error none" src="${publicImageUrl}/error.svg" alt="People's Daily English language App ">`
        const keysLen = effectImage[i]?.parentNode?.childNodes?.length || 0
        if (effectImage[i]?.parentNode) {
          for (let a = 0; a < keysLen; a += 1) {
            // @ts-ignore
            if (effectImage[i]?.parentNode?.childNodes?.item(a)?.tagName === 'IMG') {
              if (a > 0 && !!effectImage[i]?.parentNode?.childNodes?.item(a - 1)?.textContent) {
                el.style.marginTop = isMobile ? '0.6rem' : '24px'
              }
            }
          }
        }

        effectImage[i].before(el)
        effectImage[i].remove()
        nextCallback(1, src)
        nextCallback(1, src)
      }
    }
  }
  const videoOutter = []

  for (let i = 0; i < videoDom.length; i++) {
    const parentNode: HTMLElement = videoDom[i].parentNode as any
    if (parentNode.getAttribute('id') === 'newContent') {
      videoOutter.push(videoDom[i])
    }
  }

  for (let i = 0; i < videoOutter.length; i++) {
    const outterEl = document.createElement('p')
    outterEl.setAttribute('class', 'en-video-outter-content')
    outterEl.append(videoOutter[i].cloneNode())
    videoOutter[i].before(outterEl)
    videoOutter[i].remove()
  }

  const videoDomList = document.querySelectorAll('#newContent video')
  console.log('videoDomList', videoDomList)
  console.log('videoDomList', videoDomList[0])

  for (let i = 0; i < videoDomList.length; i++) {
    let width: any = 0
    let height: any = 0
    const videoEl: any = videoDomList[i]
    const videoElId = `origin-video-${i}`
    videoEl.setAttribute('id', videoElId)
    videoEl.setAttribute('class', 'en-origin-video')
    const src = videoDomList[i].getAttribute('src')
    if (!src) break
    if (videoEl && videoEl.style.display === 'none') break
    if (videoDomList[i].getAttribute('style')) {
      const style = videoDomList[i]?.getAttribute('style')?.split(';')
      style.forEach((el) => {
        if (el.includes('width') && !el.includes('max')) {
          width = el.includes('width: ') ? el.split('width: ')[1] : el.split('width:')[1]
        } else if (el.includes('height') && !el.includes('max')) {
          height = el.includes('height: ') ? el.split('height: ')[1] : el.split('height:')[1]
        }
      })
    }
    const id = getRandomNumber().uuid(10)
    const poster = videoDomList[i].getAttribute('poster')
    const el = document.createElement('div')
    el.setAttribute('class', 'preview-video init')
    el.innerHTML = `<div id="video-player-${i}" class="video-player video-player-${i}" data-height="${
      height || '0'
    }" data-width="${width || '0'}" data-id="${id}"></div>`
    const parentNode: HTMLElement = videoDomList[i].parentNode as any

    if (parentNode) {
      parentNode.before(el)
        // 问题，现在存在<p><video/></p>、<video></video>两种结构，不确定是如何产生的，需要做兼容
      if (parentNode.tagName === 'P') {
        parentNode.remove()
      } else {
        parentNode.removeChild(videoEl)
      }
    }
    nextCallback(2, { src, id, poster, originId: videoElId })
  }

  const lastEle: HTMLElement = document.querySelector('#newContent')
    ?.lastElementChild as HTMLElement

  if (lastEle) {
    if (lastEle.childNodes && lastEle.childNodes.length === 1) {
      // @ts-ignore
      if (lastEle.childNodes[0].tagName === 'BR') {
        if (lastEle.previousElementSibling) {
          // @ts-ignore
          lastEle.previousElementSibling.style.setProperty('margin-bottom', '0', 'important')
        }
      }
    } else {
      lastEle.style.setProperty('margin-bottom', '0', 'important')
    }
  }

  if (document.querySelector('.skeleton-loading')) {
    document.querySelector('.skeleton-loading').classList.add('none')
  }

  document
    .getElementById('newContent')
    .setAttribute('class', type === 'pc' ? 'c-news-content' : 'news-content')
}
